export const getDonationTypeForFrequency = (frequency) => {
  if (frequency === 'ONE_TIME') {
    return 'Once';
  }

  return frequency ? 'Repeat' : 'Once';
};

export const clearScheduledDonationState = ({
  setStartDate,
  setEndDate,
  setTimeValue,
  setScheduledDonationsOpen,
}) => {
  setStartDate(null);
  setEndDate(null);
  setTimeValue(null);
  setScheduledDonationsOpen(false);
};

export const resetCustomInputsAnswers = (customInputs = []) => {
  return customInputs.map((input) => ({
    ...input,
    answers: [''],
  }));
};

export const getScheduledDonationValidationErrors = ({
  showScheduledDonations,
  selectedFrequency,
  scheduledDonationsOpen,
  startDate,
  endDate,
  timeValue,
  startDateMessage = 'Please input a start date that is today or in the future',
  endDateMessage = 'Please input an end date that is today or in the future',
  timeMessage = 'Please select a time for your scheduled donation',
}) => {
  const shouldValidate =
    showScheduledDonations
    && selectedFrequency !== 'ONE_TIME'
    && scheduledDonationsOpen
    && (startDate || endDate || timeValue);

  if (!shouldValidate) {
    return {
      shouldValidate: false,
      startDateError: '',
      endDateError: '',
      timeError: '',
    };
  }

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  let startDateError = '';
  let endDateError = '';
  let timeError = '';

  if (startDate) {
    const startDateValue = typeof startDate === 'string'
      ? new Date(`${startDate}T00:00:00`)
      : new Date(startDate);
    startDateValue.setHours(0, 0, 0, 0);

    if (startDateValue < today) {
      startDateError = startDateMessage;
    }
  }

  if (endDate) {
    const endDateValue = typeof endDate === 'string'
      ? new Date(`${endDate}T00:00:00`)
      : new Date(endDate);
    endDateValue.setHours(0, 0, 0, 0);

    if (endDateValue < today) {
      endDateError = endDateMessage;
    }
  }

  if (startDate && !timeValue) {
    timeError = timeMessage;
  }

  return {
    shouldValidate: true,
    startDateError,
    endDateError,
    timeError,
  };
};
